import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation } from "react-router-dom";
import { getItemMenu, getItemsTeasaureByParent, getLineaTiempo } from "../../assets/js/api";
import { translate } from "../../assets/js/functions";

export default function LineaTiempo({ section_id }) {
    const location = useLocation();
    const [lineasTiempo, setLineasTiempo] = useState(null);
    const [idLineaDictadura, setLIdLineaDictadura] = useState(null);
    const [idLineaProfesorado, setLIdLineaProfesorado] = useState(null);
    const [itemsLinea, setItemsLinea] = useState({});
    const [item, setItem] = useState(location.state?.item || null);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    useEffect(() => {
        if (item) {
            getItemsTeasaureByParent(item, null, true).then((data) => {
                setLineasTiempo(data || null);
                setLIdLineaDictadura(data[0].section_id);
                setLIdLineaProfesorado(data[1].section_id);
            });
        }
    }, [item]);

    useEffect(() => {
        if (lineasTiempo && item && lineasTiempo.length > 0) {
            lineasTiempo.forEach((linea) => {
                getLineaTiempo(item, linea, false).then((data) => {
                    setItemsLinea((prevItems) => ({
                        ...prevItems,
                        [linea.section_id]: data,
                    }));

                });

            });
        }

    }, [lineasTiempo, item]);

    const createTitle = (title) => {
        const words = title.split(" ");
        if (words.length >= 2) {
            words[words.length - 1] = (
                <span className="has-text-primary">{words[words.length - 1]}</span>
            );
        }
        return (
            <>
                {words.map((word, index) => (
                    <React.Fragment key={index}>
                        {word}
                        {index < words.length - 1 && " "}
                    </React.Fragment>
                ))}
            </>
        );
    };

    // Group events by year for all lines
    const eventsByLineYear = {};
    const yearsList = [];

    if (itemsLinea) {

        Object.keys(itemsLinea).forEach((sectionId) => {
            itemsLinea[sectionId].forEach((event) => {
                const year = new Date(event.date_in * 1000).getFullYear(); // Convert to year
                if (!eventsByLineYear[sectionId]) {
                    eventsByLineYear[sectionId] = {};
                }
                if (!eventsByLineYear[sectionId][year]) {
                    eventsByLineYear[sectionId][year] = [];
                }
                eventsByLineYear[sectionId][year].push(event);
                if (!yearsList.includes(year)) {
                    yearsList.push(year);
                }
            });


        });

        yearsList.sort((a, b) => a - b);

    }


    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--l">
                        <h1 className="has-text-centered">{item ? createTitle(item.term) : ""}</h1>
                    </div>
                    <div className="wrapper mt-8">
                        <div className="is-flex is-hidden-mobile mb-6 has-text-weight-bold is-size-5 gap-5 is-justify-content-space-between">
                            <p>
                                {translate("Línea de tiempo de la guerra civil y la dictadura")}

                            </p>
                            <p className="has-text-right">{translate("Línea de tiempo de la represión del profesorado")}

                            </p>
                        </div>
                        <ol className="timeline flow--xl">
                            {yearsList.map((year) => (
                                <li key={year}>
                                    <h2>{year}</h2>

                                    {eventsByLineYear[idLineaDictadura] && eventsByLineYear[idLineaDictadura][year] ? (
                                        <div className="left flow is-size-7">
                                            {eventsByLineYear[idLineaDictadura][year].length > 0 ? (
                                                <ul>
                                                    {eventsByLineYear[idLineaDictadura][year].map((event, index) => (
                                                        <li key={`${year}-${index}`}>
                                                            <strong>{event.term || ''} </strong>{event.abstract || ''}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : ''}
                                        </div>
                                    ) : (
                                        <div className="left flow is-size-7">
                                        </div>
                                    )}

                                    {eventsByLineYear[idLineaProfesorado] && eventsByLineYear[idLineaProfesorado][year] ? (
                                        <div className="right flow is-size-7">
                                            {eventsByLineYear[idLineaProfesorado][year].length > 0 ? (
                                                <ul>
                                                    {eventsByLineYear[idLineaProfesorado][year].map((event, index) => (
                                                        <li key={`${year}-${index}`}>
                                                            <strong>{event.term || ''} </strong>{event.abstract || ''}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : ''}
                                        </div>
                                    ) : (
                                        <div className="right flow is-size-7">
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ol>
                    </div>
                </main>
                <Footer />
            </div>
        </Layout>
    );
}